import { render } from "./FormSuccess.vue?vue&type=template&id=1d997b51&scoped=true"
const script = {}

import "./FormSuccess.vue?vue&type=style&index=0&id=1d997b51&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/lauryncoleman/lauryncoleman/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d997b51"]])

export default __exports__